import React from 'react';
import { MODULES } from '../../../common/constants';
import PageHeader from '../../../components/PageHeader';
import CommonIconForm from './CommonIconForm';

const AddEditIcon = () => {
  return (
    <>
      <PageHeader menu={MODULES?.ASSETS} />
      <div className="page-wrapper">
        <div className="page-wrapper-body">
          <CommonIconForm />
        </div>
      </div>
    </>
  );
};

export default AddEditIcon;
